module.exports = __webpack_public_path__ + "img/BAU_Partners_13.acbbaa07.jpg";